<template>
  <dev>
    <div class="simple-card" style="background-color: #F8F8F8">
      <div style="position: relative; z-index:2">
        <h3 class="simple-card-title" style="margin: 0;">{{$t("pages.exams.ratingResults.leaderboard")}}
          <a v-if="showInfo" @click.prevent="showInfoModal"> <i class="fa fa-info-circle" style="font-size: 20px"></i></a>
        </h3>
        <span v-if="progress < 75" class="simple-card-content">{{$t("pages.exams.ratingResults.completeMoreQuizes")}}</span>
        <span v-else class="info-box-number">{{$t("pages.exams.ratingResults.joinedLeaderboard")}}</span>
        <div v-if="progress < 75" class="progress-container">
          <div class="progress-eighty" />
          <div class="progress" :style="'background-color: #0073B7; width:' + progress + '%'"></div>
        </div>
        <span v-else class="progress-description">{{$t("pages.exams.ratingResults.improveRating")}}</span>
      </div>
    </div>
  
    <!-- info modal-->
    <div class="modal modal-success fade" :id="modalInfoKey" v-if="showInfoModalBoolean">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.exams.ratingResults.infoTitle')}}</h4>
          </div>
          <div class="modal-body">
            <p>{{$t('pages.exams.ratingResults.info')}} </p>
            <p>{{$t('pages.exams.ratingResults.infoDeviation')}}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline pull-left" data-dismiss="modal">{{$t('pages.reports.close')}}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
  </dev>
</template>
<script>
import crypto from 'crypto'

export default {
  name: 'leaderboard-card',
  props: ['color', 'showInfo', 'progress'],
  data () {
    return {
      showInfoModalBoolean: false,
      modalInfoKey: 'modal-info-' + this.getUniqueKey()
    }
  },
  methods: {
    showInfoModal () {
      return new Promise((resolve, reject) => {
        console.log('eee')
        this.showInfoModalBoolean = true
        resolve()
      }).then(() => {
        window.jQuery(`#${this.modalInfoKey}`).modal()
      })
    },
    getUniqueKey () { // async?
      let generated = crypto.randomBytes(20).toString('hex')
      return generated
    }
  }
}

</script>

<style scoped lang="scss">
@import '../../../assets/k6styles/cards';

.simple-card {
  height: fit-content;
}
.simple-card-content {
  font-size: 14px;
  color: rgb(58, 58, 58);
}
.progress-container {
  position: relative;
  width: 50%;
  height: 10px;
  background-color: rgba(192, 192, 192, 0.41);
  border-radius: 8px;
  margin-top: 20px;
}
.progress-eighty {
  position: absolute;
  height: 10px;
  width: 75%;
  background-color: #d0d0d0;
  border-radius: 8px;
}
.progress {
  position: absolute;
  height: 10px;
  background-color: white;
  border-radius: 8px;
}

</style>


// WEBPACK FOOTER //
// LeaderboardAccuracyCard.vue?197e39bc